// Everything above the work on the landing page.
//
// Two tiers, in reading order:
//   1. Who — the disciplines, the largest type on the page, with the post named
//      directly beneath it. The separators are muted so the labels read as a
//      set rather than a sentence, and the lab is left out of the post.
//   2. What, and what to do about it — the line introducing the work sits on
//      the same row as the standing actions, left and right, the way the footer
//      is set. Reading down the left edge gives name, post, work; the right
//      edge holds the two things a visitor might want to take away.

import React from "react";
import {
  actionButtonPrimaryClass,
  actionButtonSecondaryClass,
  homeIntroStatementClass,
  homeIntroTitleClass,
  homeIntroTitleMutedClass,
  homeSectionLabelClass,
} from "../../tokens";

const CV_URL = "/General/Shareef Jasim _ Resume.pdf";
const EMAIL_URL = "mailto:shareefjasim1@gmail.com";

export const DISCIPLINES = [
  "Researcher",
  "Computational Designer",
  "Creative Technologist",
];

const AFFILIATION =
  "Currently \u00b7 Research Scientist, University of Washington";

// One sentence, naming the ground the projects cover and nothing else — no
// claim about how good any of it is, which the projects can make for
// themselves. Set to an empty string to leave the row as the actions alone.
const STATEMENT =
  "Selected work showcased below, spanning architecture, computational tooling, and research hardware.";

const LandingMasthead = ({ showActions = true }) => (
  <header className="pt-10 lg:pt-16">
    <h1 className={homeIntroTitleClass}>
      {DISCIPLINES.map((discipline, i) => (
        <React.Fragment key={discipline}>
          {i > 0 && (
            <>
              {" "}
              <span aria-hidden="true" className={homeIntroTitleMutedClass}>
                &middot;
              </span>{" "}
            </>
          )}
          {discipline}
        </React.Fragment>
      ))}
    </h1>

    <p className={`${homeSectionLabelClass} mt-3 lg:mt-4`}>{AFFILIATION}</p>

    {/* items-start so the sentence begins level with the top of the buttons
        however many lines it runs to. */}
    <div className="mt-10 lg:mt-14 flex flex-wrap items-start justify-between gap-x-10 gap-y-6">
      {STATEMENT && <p className={homeIntroStatementClass}>{STATEMENT}</p>}

      {showActions && (
        <div className="flex flex-wrap items-center gap-3">
          <a
            href={CV_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-cursor="pointer"
            className={actionButtonPrimaryClass}
          >
            <span>Download CV</span>
            <span aria-hidden="true">&darr;</span>
          </a>
          <a
            href={EMAIL_URL}
            data-cursor="pointer"
            className={actionButtonSecondaryClass}
          >
            <span>Email me</span>
            <span aria-hidden="true">&#x2197;</span>
          </a>
        </div>
      )}
    </div>
  </header>
);

export default LandingMasthead;
